import React from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Image, Table, Spinner, Alert, Card } from "react-bootstrap";

import Layout from '../../components/Layout/Layout';

export default function Success() {

    const location = useLocation();
    const message = location.state?.message || "Successful";

    return (
        <>
            <Layout>

                <Container>

                    <div className="page_main_title">
                        <h1>Apply Loan</h1>
                        <p>Where Ownership Begins</p>
                    </div>

                    <div className="box mt-4">
                        <Row className="row_gap">
                            <Col md={12}>
                                <div className="inner_box text-center">
                                    <h3 className="box_title" style={{ color: "#73cf73" }}>Success</h3>
                                    <div className="text">
                                        {message.split("\n").map((line, idx) => (
                                            <p key={idx}>{line}</p>
                                        ))}
                                    </div>
                                    <div className="button">
                                        <Button as={Link} to="/landing/apply-loan" variant="outline-light">OK</Button>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>

                </Container>

            </Layout>
        </>
    );
}